import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent } from "@/types/types";
import { mergeGamePointsForGame } from "./gamePointsMergeHandler";

type SaveRoundTargetValueConfig = {
	eventDataSource: IEventDataSource;
	event: BigBashEvent;
	gameId: string;
	roundNumber: number;
	value: number;
};

export async function saveRoundTargetValue(config: SaveRoundTargetValueConfig): Promise<BigBashEvent> {
	const updatedGamePoints = await config.eventDataSource.setRoundTargetValue(
		config.event.id, config.gameId, config.roundNumber, config.value
	);
	return { ...config.event, game_points: mergeGamePointsForGame(config.event, config.gameId, updatedGamePoints) };
}
